export default __webpack_public_path__ + "static/media/logo.d1203cc0.svg";